import type { DeviceInfo } from './types';

const VISITOR_ID_KEY = 'flamio_vid';

export function getOrCreateVisitorId(): string {
  try {
    const stored = localStorage.getItem(VISITOR_ID_KEY);
    if (stored) return stored;
    const id = crypto.randomUUID();
    localStorage.setItem(VISITOR_ID_KEY, id);
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

export function getDeviceInfo(): DeviceInfo {
  return {
    userAgent: navigator.userAgent,
    screenWidth: screen.width,
    screenHeight: screen.height,
    language: navigator.language,
    platform: navigator.platform,
  };
}

export function getUtmParams(): Record<string, string> {
  const params: Record<string, string> = {};
  try {
    const search = new URLSearchParams(window.location.search);
    const utmKeys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];
    for (const key of utmKeys) {
      const value = search.get(key);
      if (value) params[key] = value;
    }
  } catch {
    // noop
  }
  return params;
}
